"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");

var ImpactConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ImpactConverter, _DataObjectConverter_);

  function ImpactConverter() {
    _classCallCheck(this, ImpactConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ImpactConverter).apply(this, arguments));
  }

  return ImpactConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ImpactConverter = ImpactConverter;